

















import { Component, Mixins } from "vue-property-decorator";
import { DeveloperIndicator } from "../../../developer";
import { PatientFeatureAccessibleMixin } from "../../../patient/mixins";
import { ModelEditableMixin } from "../../../system/mixins";
import { ReferenceFileMenu } from "../../../document/editor/contents";
import { DocumentStructureEditableMixin, DocumentEditInformationEditableMixin } from "../mixins";
import {
  DrawModeSelector,
  FreeInputSelector,
  PageNumberSelector,
  EditScaleSelector,
  CalculationMenu,
  PreviewMenu,
  ExtraPageMenu,
  HisInformationMenu,
  PatientProfileMenu,
  TransparentSelector,
} from "./editMenus";
import DocumentAttributesEditor from "./DocumentAttributesEditor.vue";

@Component({
  components: {
    DocumentAttributesEditor,
    DrawModeSelector,
    FreeInputSelector,
    PageNumberSelector,
    EditScaleSelector,
    CalculationMenu,
    PreviewMenu,
    ExtraPageMenu,
    HisInformationMenu,
    PatientProfileMenu,
    DeveloperIndicator,
    ReferenceFileMenu,
    TransparentSelector,
  },
})
export default class EmbeddedEditMenuContainer extends Mixins(ModelEditableMixin, DocumentStructureEditableMixin, DocumentEditInformationEditableMixin, PatientFeatureAccessibleMixin) {
  get isDocumentAlreadyInitialized(): boolean {
    return this.isSourceEnable
      && this.editingSource.isAlreadyInitialized;
  }
}
